<template>
    <div>
        <Modal v-model="modelShow" :title="title" width="1200">
            <template v-if="entityShow">
                <table-title>计价模型信息</table-title>
                <data-grid v-if="tatbleShow" :columns="entityCols" :queryParams="{}" :autoLoad="false" :pagination="false" subListName :dataList="entityList">
                    <template #default="{columns, data}">
                        <Table :columns="columns" :data="data" :width="800" border stripe size="small"></Table>
                    </template>
                </data-grid>
            </template>
            <template v-else>
                <table-title>租赁框架协议列表</table-title>
                <data-grid v-if="tatbleShow" :columns="frameRentCols" :queryParams="{}" :autoLoad="false" :pagination="false" subListName :dataList="frameRentList">
                    <template #default="{columns, data}">
                        <Table :columns="columns" :data="data" :width="1100" border stripe size="small" style="margin:10px"></Table>
                    </template>
                </data-grid>
            </template>

            <table-title>计费增值费列表</table-title>
            <data-grid v-if="tatbleShow" :columns="addedFeeCols" :queryParams="{}" :autoLoad="false" :pagination="false" subListName :dataList="addedFeeList">
                <template #default="{columns, data}">
                    <Table :columns="columns" :data="data" :width="800" border stripe size="small"></Table>
                </template>
            </data-grid>
            <table-title>计费模型附加运费列表</table-title>
            <Table v-if="tatbleShow" :columns="adtlRecycleCols" :data="adtlRecycleList" border stripe size="small" :width="800"></Table>
            <table-title>计费模型区域运费列表</table-title>
            <data-grid v-if="tatbleShow" :columns="areaLogisticsCols" :queryParams="{}" :autoLoad="false" :pagination="false" subListName :dataList="areaLogisticsList">
                <template #default="{columns, data}">
                    <Table :columns="columns" :data="data" :width="800" border stripe size="small" style="margin-bottom:10px"></Table>
                </template>
            </data-grid>
            <table-title>计费模型阶梯列表</table-title>
            <Table v-if="tatbleShow" :columns="stairFeeCols" :data="stairFeeList" border stripe size="small" :width="800"></Table>
            <div slot="footer">
                <Button type="primary" @click="close">关闭</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import tableTitle from '@/components/tableTitle/tableTitle.vue'
import dataGrid from '@/components/datagrid.vue'
export default {
    components: { tableTitle, dataGrid },
    data() {
        return {
            title: "",
            modelShow: false,
            tatbleShow: true,
            entityShow:false,
            entityList: [],//计价模型信息
            entityCols: [
                { title: "计费模型编号", key: 'id' },
                { title: "模式类型", key: 'modelId',dict:['default','billingModel',true] },
                { title: "免租天数", key: 'noBillingTerm' },
                { title: "超期租金", key: 'overdueRental' },
                { title: "超期服务费", key: 'overdueService' },
                { title: "打包租金", key: 'packageRental' },
                { title: "打包服务费", key: 'packageService' },
                { title: "租期", key: 'rentTerm' },
            ],
            frameRentCols: [
                { title: '框架协议编号', key: 'id' },
                { title: '框架协议名称', key: 'frameName' },
                { title: '计价模型编号', key: 'billingModelId' },
                { title: '计价模型名称', key: 'name' },
                // { title: '动态策略编号', key: 'strategyId' },
                { title: '参与人', key: 'memberId', dict: ['bizObjects', 'member', true] },
                // { title: '指定合伙人', key: 'leaserId', dict: ['bizObjects', 'member', true] },
                { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true] },
                { title: '是否默认框架协议', key: 'defaultFlag', dict: ['default', 'bitYesNo'] },
                // { title: '计费模式类型', key: 'billingModeType', dict: ['default', 'billingModeType'] },
                { title: '模式类型', key: 'modelId', dict: ['default', 'billingModel'] },
                { title: "约定期限", key: "rentTerm" },
                { title: '免费租期', key: 'noBillingTerm' },
                { title: '生效日', key: 'validDate',formatter:'date' },
                { title: '失效日', key: 'invalidDate',formatter:'date' },
                { title: '最大租数', key: 'maxAmount' },
                { title: '最小停租日', key: 'minBillingStopDate',formatter:'date' },
                { title: '最小计租天数', key: 'minBillingDays' },
                { title: '押金单价', key: 'depositUnit' },
                { title: '是否有效', key: 'validFlag', dict: ['default', 'YesNo'] },

            ],
            addedFeeCols: [
                { title: "计费模型编号", key: 'billingModelId' },
                { title: "增值费类型", key: 'feeType', dict: ['default', 'feeType'] },
                { title: "增值费单价", key: 'unitPrice' },
                { title: "背对背标志", key: 'backToBackFlag', dict: ['default', 'bitYesNo'] },
            ],
            adtlRecycleList: [],//计费模型附加运费列表
            adtlRecycleCols: [
                { title: "计费模型编号", key: 'billingModelId' },
                { title: "开始天数", key: 'startDays' },
                { title: "截止天数", key: 'endDays' },
                { title: "附加运费单价", key: 'adtlRecyclePrice' },
            ],
            areaLogisticsList: [],//计费模型区域运费列表
            areaLogisticsCols: [
                { title: "计费模型编号", key: 'billingModelId' },
                { title: "省市区", key: 'areaId', dict: ['region', 'fullArea', true] },
                { title: "配送费单价", key: 'deliverPrice' },
                { title: "回收费单价", key: 'recyclePrice' },
            ],
            stairFeeList: [],//计价模型阶梯列表
            stairFeeCols: [
                { title: "计费模型编号", key: 'billingModelId' },
                { title: "开始天数", key: 'startDays' },
                { title: "截止天数", key: 'endDays' },
                { title: "租金价格 ", key: 'rentalPrice' },
                { title: "服务费价格 ", key: 'servicePrice' },

            ]
        }
    },
    methods: {
        openModal(frameId, flag) {
            console.log(flag)
            this.modelShow = true
            if (flag) {
                this.title = '计价模型详情信息'
                this.getModelDetail(frameId)
                this.entityShow = true
            } else {
                this.getData(frameId)
                this.title = '租赁框架协议详情信息'

            }

        },
        getData(frameId) {
            let data = {
                url: "CORE-CONTRACT/messageService/queryService/queryFrame",
                body: { frameId }
            }
            this.tatbleShow = false
            this.invoke(data).then(res => {
                if (res) {
                    delete res.billingModel.id;
                    let obj = { ...res.frame_rent, ...res.billingModel }
                    obj.frameName = res.frame_rent.name;
                    this.frameRentList = [obj];

                    this.addedFeeList = res.BillingModelAddedFeeList
                    this.adtlRecycleList = res.BillingModelAdtlRecycleFeeList
                    this.areaLogisticsList = res.BillingModelAreaLogisticsList
                    this.stairFeeList = res.BillingModelStairFeeList
                    this.tatbleShow = true
                }
            }).catch(err => {
                this.tatbleShow = true
            })
        },
        // 查看计价模型详情信息调用
        getModelDetail(billingModelId) {
            let data = {
                url: "CORE-CONTRACT/messageService/billingModelService/queryBillingModelAllInfoById",
                body: { billingModelId }
            }
            this.tatbleShow = false
            this.invoke(data).then(res => {
                this.entityList = []
                if (res) {
                    console.log(res)
                    this.addedFeeList = res.billingModelAddedFeeList
                    this.adtlRecycleList = res.billingModelAdtlRecycleFeeList
                    this.areaLogisticsList = res.billingModelAreaLogisticsList
                    this.stairFeeList = res.BillingModelStairFeeList
                    this.entityList.push(res.billingModelEntity)
                    this.tatbleShow = true

                }
            }).catch(err => {
                this.tatbleShow = true
            })
        },
        close() {
            this.modelShow = false

        }
    }

}
</script>

<style lang="scss" scoped>
</style>